// Constants for undistractor tab UI interactions

export const TAB_BUTTON_SELECTOR = '.tab-btn[data-undistractor-tab-filter-tab-param';

export function buildTabSelector(tab) {
  return `${TAB_BUTTON_SELECTOR}="${tab}"]`;
}

export function updateSidebarActiveState(tab) {
  const subLinksContainer = document.querySelector('.sidebar-sub-links');
  if (!subLinksContainer) return;

  subLinksContainer.querySelectorAll('.sub-link-item').forEach((item) => {
    item.classList.remove('active');
  });

  const matchingLink = subLinksContainer.querySelector(`[data-sidebar-tab-link-tab-value="${tab}"]`);
  matchingLink?.classList.add('active');
}
